import { GeneralResourceDetailYearly } from './ResourceDetail'

export const governmentFundedProgramNames = ['eqip', 'csp', 'nwqi', 'cwi', 'wsi', 'wcir']

export type GovernmentFundedProgramNames = typeof governmentFundedProgramNames[number]

export interface GovernmentFundedDetailValue {
  isFunded: boolean
  data: {
    programs?: GovernmentFundedProgramNames[]
    otherProgram?: string
  }
}

export interface RDGovernmentFunded
  extends GeneralResourceDetailYearly<GovernmentFundedDetailValue> {
  traitId: 'governmentFunded'
}
